import PropTypes from "prop-types";
import { useMutation } from "react-query";
import { t } from "@/i18n-js/instance";
import { reactQueryDelete } from "@circle-react/helpers/backendRequestHelpers";
import { internalApi } from "@circle-react/helpers/urlHelpers";
import { useCourseSections } from "@circle-react/hooks/courses/useCoursesApi";
import { ConfirmationModal } from "@circle-react-shared/ModalsV2/ConfirmationModal";

export const ConfirmLessonDelete = ({
  show,
  name,
  onClose,
  courseId,
  sectionId,
  lessonId,
}) => {
  const { refetch: refetchCourseSections } = useCourseSections(courseId);
  const deleteLessonMutation = useMutation(
    () =>
      reactQueryDelete(
        internalApi.courses.deleteLesson({ courseId, sectionId, lessonId }),
      ),
    {
      onSuccess: async () => {
        await refetchCourseSections();
        onClose();
      },
    },
  );

  return (
    <ConfirmationModal
      isOpen={show}
      title={t("courses.edit.sections.delete_lesson")}
      onClose={onClose}
      onCancel={onClose}
      onConfirm={deleteLessonMutation.mutate}
      confirmVariant="danger"
      disabled={deleteLessonMutation.isLoading}
      confirmText={
        deleteLessonMutation.isLoading ? t("deleting") : t("confirm")
      }
    >
      {t("courses.edit.sections.delete_confirmation", { name })}
    </ConfirmationModal>
  );
};

ConfirmLessonDelete.propTypes = {
  show: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  courseId: PropTypes.string.isRequired,
  sectionId: PropTypes.string.isRequired,
  lessonId: PropTypes.string.isRequired,
};
